function TrendsGraph({ pageTitle, graphData }) {
    return (
        <div className='rounded-lg border border-[#EAEAEA] p-4 max-[1080px]:px-[14px] col-span-1 flex flex-col gap-2'>
            <h1 className='font-semibold text-base'>{pageTitle}</h1>

            <div className="m-auto">
                <h1 className='font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>

            {/* {graphData.map(item => {
                const { title, percentage, id } = item;

                return (
                    <div className="flex flex-col gap-2" key={id}>
                        <div className="flex flex-col gap-1">
                            <div className="flex items-center justify-between font-medium text-[#121212]">
                                <span className='text-[14px] leading-[22px]'>{title}</span>

                                <span className='text-[14px] leading-[22px]'>{percentage}%</span>
                            </div>

                            <div className="rounded overflow-hidden relative h-4">
                                <div className="bg-[#EAEAEA] size-full" />

                                <div className='absolute top-0 left-0 bg-[#549BFF] z-10 h-full' style={{ width: `${percentage}%` }} />
                            </div>
                        </div>
                    </div>
                );
            })} */}
        </div>
    );
}

export default TrendsGraph;
